<mpro-tag *ngIf="spending" [color]="spendingTag.color">{{
  spendingTag.text
}}</mpro-tag>
<mpro-tag *ngIf="age && !generationTag.text" [color]="ageTag.color">{{ ageTag.text }}</mpro-tag>
<mpro-tag *ngIf="gender && genderTag.text !== Gender.ALL && !category" [color]="genderTag.color">{{
  genderTag.text
}}</mpro-tag>
<mpro-tag *ngIf="category" [color]="categoryTag.color">{{
  categoryTag.text
}}</mpro-tag>
<mpro-tag *ngIf="generationTag.text" [color]="generationTag.color">{{
  generationTag.text
}}</mpro-tag>
